export default "__VITE_PUBLIC_ASSET__a80543d7__"